import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import type { components } from "@/__openapi__/backend/schema";

export type DataExport = components["schemas"]["DataExportInternalResponseSchema"];
export type CreateDataExportResponse =
  components["schemas"]["CreateDataExportInternalResponseSchema"];
export type RunDataExportResponse = components["schemas"]["RunDataExportInternalResponseSchema"];
export type TriggerZipGenerationResponse =
  components["schemas"]["TriggerZipGenerationInternalResponseSchema"];
export type DataExportDownloadUrlResponse =
  components["schemas"]["DataExportDownloadURLResponseSchema"];

export const fetchDataExport = async (dataExportId: Uuid): Promise<DataExport | undefined> => {
  const resp = await api.get("/internal/v1/data-exports/{data_export_id}", {
    params: { path: { data_export_id: dataExportId } },
  });

  return resp.data ?? undefined;
};

export const createDataExport = async (
  spaceAccountId: Uuid
): Promise<CreateDataExportResponse | undefined> => {
  const resp = await api.post("/internal/v1/data-exports/create", {
    body: {
      space_account_id: spaceAccountId,
    },
  });

  return resp.data ?? undefined;
};

export const runDataExport = async (
  dataExportId: Uuid
): Promise<RunDataExportResponse | undefined> => {
  const resp = await api.post("/internal/v1/data-exports/{data_export_id}/run", {
    params: { path: { data_export_id: dataExportId } },
  });

  return resp.data ?? undefined;
};

export const triggerZipGeneration = async (
  dataExportId: Uuid
): Promise<TriggerZipGenerationResponse | undefined> => {
  const resp = await api.post("/internal/v1/data-exports/{data_export_id}/generate-zip", {
    params: { path: { data_export_id: dataExportId } },
  });

  return resp.data ?? undefined;
};

export const fetchDataExportDownloadUrl = async (
  dataExportId: Uuid
): Promise<DataExportDownloadUrlResponse | undefined> => {
  const resp = await api.get("/internal/v1/data-exports/{data_export_id}/download-url", {
    params: { path: { data_export_id: dataExportId } },
  });

  return resp.data ?? undefined;
};
